<template>
    <div v-loading="dataLoading">
        <div class="content-box account-info first">
            <template v-if="$store.state.userType == 1">
                <ul class="list">
                    <li>
                        <span class="color-info">
                            <svg-icon icon-class="name"></svg-icon>
                            真实姓名
                        </span>
                        {{ verify.isVerify ? data && data.name : '无' }}
                        <el-button
                            type="text"
                            v-if="verify.isVerify && data && data.name"
                            @click="$contractRouter('/manage/contract/update/fdd/name')"
                            class="right underline"
                        >
                            修改姓名
                        </el-button>
                    </li>
                    <li>
                        <span class="color-info">
                            <svg-icon icon-class="card"></svg-icon>
                            身份证号码
                        </span>
                        {{ (data && data.userIdNum) || '无' }}
                    </li>
                    <li>
                        <span class="color-info">
                            <svg-icon icon-class="phone"></svg-icon>
                            手机号（登录账号）
                        </span>
                        {{ data && data.telephone }}
                        <el-button
                            v-if="data && data.telephone"
                            type="text"
                            @click="$contractRouter('/manage/contract/update/fdd/phone')"
                            class="right underline"
                        >
                            修改手机
                        </el-button>
                    </li>
                    <li>
                        <span class="color-info">
                            <svg-icon icon-class="relname"></svg-icon>
                            实名认证
                        </span>
                        <template v-if="$store.getters.userState == 1">
                            <strong class="color-base">未实名认证</strong>
                            <el-button @click="$contractRouter('/manage/contract/verify/fdd/step/1')" type="text" class="right underline">
                                认证
                            </el-button>
                        </template>
                        <template v-else-if="verify.isVerify == 3">
                            <strong class="color-danger">认证失败</strong>
                            <el-button @click="$contractRouter('/manage/contract/verify/fdd/step/1')" type="text" class="right underline">
                                认证
                            </el-button>
                        </template>
                        <template v-else>
                            <strong class="color-success">认证成功</strong>
                        </template>
                    </li>
                    <li>
                        <span class="color-info">
                            <svg-icon icon-class="relname"></svg-icon>
                            合同签署
                        </span>
                        <template v-if="$store.getters.userState == 2">
                            <strong class="color-base">未签署合同</strong>
                            <template v-if="verify.isVerify !== 3">
                                <el-button @click="$contractRouter($store.getters.goContractSigned)" type="text" class="right underline">签署</el-button>
                            </template>
                        </template>
                        <template v-if="$store.getters.userState > 2">
                            <strong class="color-success">已签约</strong>
                        </template>
                    </li>
                    <li>
                        <span class="color-info">
                            <svg-icon icon-class="time"></svg-icon>
                            服务有效期
                        </span>
                        <template v-if="$store.getters.userState >= 5">
                            <i :class="[$store.getters.userState == 5 ? 'red' : '']">{{ data.cpOrgVipVO ? data.cpOrgVipVO.endTimeStr : '' }}</i>
                            {{ $store.getters.userState == 5 ? '已过期' : '到期' }}
                            <el-button v-if="$store.state.userType != 3" @click="$router.push('/manage/pay')" type="text" class="right underline">
                                续费
                            </el-button>
                        </template>
                        <template v-if="$store.getters.userState == 3 || $store.getters.userState == 4">
                            <strong class="color-base">未支付服务年费</strong>
                            <el-button @click="$router.push('/manage/pay')" type="text" class="right underline">支付</el-button>
                        </template>
                    </li>
                </ul>
            </template>
            <enterprise :info="data" v-else></enterprise>
        </div>
    </div>
</template>

<script>
import Enterprise from './enterprise';
import {getUserCertification} from '@/api/user';
export default {
    components: {
        Enterprise,
    },
    data() {
        return {
            visible: false,
            dataLoading: false,
            data: {},
        };
    },
    computed: {
        verify() {
            return this.$store.state.verify || {};
        },
    },
    mounted() {
        this.$store.dispatch('getUserInfo');
        this.getUserInfo();
    },
    methods: {
        async getUserInfo() {
            this.dataLoading = true;
            const respnose = await getUserCertification();
            const {state, msg, result} = respnose.data;
            this.dataLoading = false;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.data = result;
        },
    },
};
</script>

<style lang="scss">
.account-info {
    .page-group-title {
        font-size: 24px;
        font-weight: bold;
        color: $--color-font-normal;
        line-height: 24px;
        margin: 50px 0 20px;
    }

    .list {
        width: 580px;
        margin: 0 auto;

        li {
            border-bottom: 1px solid $--color-border-gary1;
            color: $-text-950;
            position: relative;
            margin-bottom: 30px;
            padding-left: 30px;
            padding-bottom: 30px;

            .color-info {
                display: block;
                color: $-text-600;
                line-height: 25px;
                margin-bottom: 8px;

                .svg-icon {
                    margin-left: -30px;
                    margin-right: 12px;
                }
            }

            .icon-edit {
                background: url('~@/assets/img/icon-edit.svg');
                width: 14px;
                height: 14px;
                display: inline-block;
                cursor: pointer;
                position: relative;
                top: 2px;
                margin-left: 10px;
            }

            .el-icon-edit-outline {
                margin-left: 10px;
                font-size: 16px;
                cursor: pointer;
            }

            .red {
                color: $--color-font-error;
            }

            .right {
                position: absolute;
                right: 0px;
                top: 0px;
            }
        }
    }
}
</style>
